import { createLazyResource, createMutation, toast, useLocalization } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { boardMemberRepository } from '~/repositories/boardMemberRepository';
import type { AppointHoaBoardMemberDto } from '~/swagger/hoa/Api';

export const [BoardMembersProvider, useBoardMembers] = createMagicDoorContext('BoardMembers', () => {
  const { t } = useLocalization();
  const [members, membersActions] = createLazyResource(() => boardMemberRepository.list({ active: true }));
  const appoint = createMutation(async (payload: AppointHoaBoardMemberDto) => {
    const response = await boardMemberRepository.appoint(payload);
    membersActions.refetch();
    toast(t('Board member appointed'), 'success');
    return response;
  });
  const deactivate = createMutation(async (id: string) => {
    const response = await boardMemberRepository.deactivate(id);
    membersActions.refetch();
    toast(t('Board member deactivated'), 'success');
    return response;
  });
  const getMember = (id: string) => boardMemberRepository.get(id);
  const getMemberByOwner = (ownerId: string) => boardMemberRepository.getByOwner(ownerId);

  return {
    members,
    fetchMembers: membersActions.fetch,
    refetch: membersActions.refetch,
    appoint,
    deactivate,
    getMember,
    getMemberByOwner,
  };
});
